import React, { useState } from "react";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { _forget_my_password } from "../api";
import { func_forget_password } from "../functions";
import useMutationForgetPassword from "../api/mutations";

const useLogicForgetPassword = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // used when data success.
    const [changeContent, setChangeContent] = useState(false);

    const { mutate_forgotten_password, loadingRequest } =
        useMutationForgetPassword({
            onSuccess: (response) => {
                if (response.success) {
                    return setChangeContent(true);
                }
            },
            onError: (error) => {
                console.log("error", error);
                return setChangeContent(false);
            },
        });

    const { email } = location.state || {};

    return {
        functions: {
            sendMail: () =>
                func_forget_password.sendMail(email, mutate_forgotten_password),
            goBack: () => func_forget_password.goBack(navigate, email),
        },
        navigate,
        isSuccessfullyUpdated: changeContent,
        currentEmail: email,
        mutation: {
            isLoading: loadingRequest,
            mutate: mutate_forgotten_password,
        },
    };
};

export default useLogicForgetPassword;
